import * as r from 'ramda';
import { isNotNil } from 'ramda-adjunct';
import { formNameToTld } from '../tld/utils';

const formatFieldValues = (value) => {
  return r.when(
    r.is(Object),
    r.pipe(
      r.filter(r.equals(true)),
      r.keys,
      r.map(formNameToTld),
      r.join(' '),
    ),
  )(value);
};

export const mapFiltersToGa = (filters, originalFilters) => {
  return r.pipe(
    r.mapObjIndexed((value, key) => {
      if (r.equals(value, originalFilters[key])) {
        return void 0;
      }

      return {
        hitType: 'event',
        eventCategory: 'Filters',
        eventAction: 'updated',
        eventLabel: key,
        dimension4: formatFieldValues(value),
      };
    }),
    r.values,
    r.filter(isNotNil),
  )(filters);
};

export default null;
